import { useState } from "react"
import { nanoid } from "nanoid"
import StyledItem, { StyledItemProps } from "./styles/ItemStyles"
import { useDropdown } from "./Root"

type ItemProps = {
  children: string
  onSelect?: (event: React.MouseEvent) => void
  value: string
  /**
	Optional text used for typeahead purposes. By default the typeahead behaviour will use the .textContent of the item. Use this when the content is complex, or you have non-textual content inside.
	**/
  textValue?: string
}

type Props = ItemProps & StyledItemProps

export const Item = ({ children, onSelect, value, ...rest }: Props) => {
  const [hasFocus, setHasFocus] = useState(false)
  const { dispatch } = useDropdown(`Item`)
  const key = nanoid()

  return (
    <StyledItem
      id={key}
      onMouseOver={() => setHasFocus(true)}
      onMouseOut={() => setHasFocus(false)}
      focus={hasFocus}
      onMouseDown={(event) => {
        dispatch({ type: `selectItem`, item: value })
        onSelect?.(event)
      }}
      {...rest}
    >
      {children}
    </StyledItem>
  )
}

Item.defaultProps = {
  onSelect: undefined,
  textValue: undefined,
}
